/* The landing page is embedded in the vammo.com home, in place of the "pit stop" section,
   as a cross-origin iframe. The parameter is what tells the same bundle to drop its own
   header and lay itself out horizontally inside that section. */
const EMBED_KEY = 'inside-vammo-landing';

/* Only this value counts. Sales sends the standalone page over WhatsApp, so a stray
   parameter must never strip the header and the language switch off it — and a boolean
   read as "any non-empty string is true" is exactly how a `?dryRun=false` once ran a
   silent dry run in production. */
const EMBED_VALUE = '1';

export const isEmbedded = (search: string): boolean => {
  for (const [key, value] of new URLSearchParams(search)) {
    if (key.toLowerCase() === EMBED_KEY && value === EMBED_VALUE) {
      return true;
    }
  }
  return false;
};
